import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import styled from 'styled-components';

import { CommunicationMessageTypes, LessonControlMessage } from '../../helpers/constants';
import useCommunicator from '../../hooks/useCommunicator';
import { IControlMessage, LessonControlTypes } from '../../types/communicator-types';

const Head = styled.h3<any>`
  margin-left: 20px;
`;

const Logout: React.FunctionComponent = () => {
  const communicator = useCommunicator<IControlMessage>(
    CommunicationMessageTypes.ControlMessage
  );
  useEffect(() => {
    (window as any).logoutInitiator = true;
    communicator?.postMessage({
      controlMessage: LessonControlMessage.LOGOUT_ON_EXIT,
      type: LessonControlTypes.LessonControl,
      monitor: '',
    });
  }, []);
  return <Head>You have been logged out.</Head>;
};

export default withRouter(Logout);
